import { useHttpClient } from '@/common/api/httpClient';
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';

export const useAuthStore = defineStore('auth', () => {
  const router = useRouter();

  let initialized = false;
  const isAuthenticated = ref(false);
  const name = ref('');
  const isAdmin = ref(false);
  const isUser = ref(false);
  const isSystemAdmin = ref(false);

  const initials = computed(() => {
    const parts = name.value.split(' ');

    if (parts.length > 1) {
      if (
        parts[0] &&
        parts[0].length > 0 &&
        parts[0][0] &&
        parts[1] &&
        parts[1].length > 0 &&
        parts[1][0]
      ) {
        return parts[0][0] + parts[1][0];
      }

      return '';
    } else if (parts.length > 0) {
      if (parts[0] && parts[0].length > 0 && parts[0][0]) {
        return parts[0][0];
      }
      return '';
    } else {
      return '';
    }
  });

  async function initialize() {
    if (initialized) return;
    return fetchFromServer();
  }

  async function fetchFromServer() {
    const httpClient = useHttpClient();

    const headers = httpClient.defaultHeaders();
    const request = new Request('api/auth', {
      method: 'GET',
      headers,
    });

    const response = await httpClient.execute(request);

    if (response.ok) {
      const info = (await response.json()) as AuthResponse;
      name.value = info.name;
      isUser.value = info.isUser;
      isAdmin.value = info.isAdmin;
      isSystemAdmin.value = info.isSystemAdmin;
      isAuthenticated.value = true;
    } else {
      name.value = '';
      isAuthenticated.value = false;
      isUser.value = false;
      isAdmin.value = false;
      isSystemAdmin.value = false;
    }

    initialized = true;
  }

  async function logout() {
    await router.replace({ name: 'logout' });
  }

  function process(response: Response) {
    if (response.status !== 401) return;
    isAuthenticated.value = false;
  }

  return {
    isAuthenticated,
    name,
    initials,
    isAdmin,
    isUser,
    isSystemAdmin,
    initialize,
    update: fetchFromServer,
    logout,
    process,
  };
});

interface AuthResponse {
  name: string;
  isUser: boolean;
  isAdmin: boolean;
  isSystemAdmin: boolean;
}
